import { render } from "./InfosList.vue?vue&type=template&id=19eded88"
import script from "./InfosList.vue?vue&type=script&lang=js"
export * from "./InfosList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__